import React, { useEffect, useState } from 'react'

import { get } from '@js/common/api'
import User from '@js/common/user'

import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'

const VendorSalesAgentsList = ({ vendorNid, officeNid, isLocalSalesAgent }) => {
  const postcode = User.getLocation().postcode
  const [faces, setFaces] = useState(null)

  useEffect(() => {
    if (!officeNid || faces) return
    get(`sales-offices/?vendor_nid=${vendorNid}&nid=${officeNid}`).then(
      data => {
        setFaces(data[0]?.faces)
      }
    )
  }, [officeNid])

  const [showPhoneNumber, setShowPhoneNumber] = useState([])

  const handleShowPhoneNumber = id => {
    setShowPhoneNumber(() => [...showPhoneNumber, id])
  }

  const isLocalSalesPerson = person =>
    (person.display_delivery_regions || []).includes(postcode)

  if (!faces) return null

  if (isLocalSalesAgent) {
    if (postcode) {
      const localSalesAgent = faces
        .filter(agent => agent.active)
        .filter(isLocalSalesPerson)

      return localSalesAgent.length ? (
        <>
          <span className='[ f-d-bl f-t-tminor f-m-t-040 f-m-b-020 ]'>
            {localSalesAgent.length === 1 ? 'Ihr lokaler ' : 'Ihre lokalen '}
            Berater
          </span>
          {faces
            .filter(agent => agent.active)
            .filter(isLocalSalesPerson)
            .map(person => (
              <div className='[ f-pos-rel f-c-bo-pri f-shadow f-c-ba-whi f-p-a-020 f-p-t-040 f-m-v-010 f-t-centre ] VendorOfficesPage-local-agent'>
                {person.avatar ? (
                  <img
                    src={person.avatar}
                    className='[ f-bo-round ]'
                    width='64'
                    height='64'
                  />
                ) : (
                  <Icon
                    icon='author-64px-fill'
                    className='[ f-icon-080 f-c-fi-pri ]'
                  />
                )}
                <div className='[ f-t-body f-m-t-010 ]'>
                  {person.first_name} {person.last_name}
                </div>
                {person.phone ? (
                  <CTA
                    type='text-primary'
                    tag='button'
                    className='[ f-p-h-020 -p-t-005 f-t-body ] '
                    href={showPhoneNumber ? `tel:${person.phone}` : null}
                    onClick={() => handleShowPhoneNumber(person.id)}>
                    {showPhoneNumber.includes(person.id)
                      ? person.phone
                      : 'Telefonnummer anzeigen'}
                  </CTA>
                ) : null}
              </div>
            ))}
        </>
      ) : null
    } else {
      return null
    }
  }

  const localSalesAgentTeam = faces.filter(agent => agent.active)

  return localSalesAgentTeam.length ? (
    <div className='[ f-p-a-020 ]'>
      <h2 className='[ f-t-tminor f-m-a-0 f-p-t-040 f-p-b-020 ]'>Team</h2>
      <div className='[ f-g-r ]'>
        {faces
          .filter(agent => agent.active)
          .map(person => (
            <div className='[ f-g-c24 f-g-c8:m f-m-v-010 ]'>
              <div
                className={`[ f-pos-rel f-radius-card-large f-shadow f-c-ba-whi f-p-h-010 f-p-v-030 f-m-v-010 f-t-centre f-h-100 ${
                  isLocalSalesPerson(person) ? 'f-c-bo-pri' : ''
                } ] ${
                  isLocalSalesPerson(person)
                    ? 'VendorOfficesPage-local-agent'
                    : ''
                }`}>
                {isLocalSalesPerson(person) ? (
                  <div className='[ f-pos-ab f-d-iflr f-c-ba-pri f-c-fo-whi f-t-micro f-p-a-005 ] VendorOfficesPage-local-agent-tag'>
                    <Icon
                      icon='pin-check-16px'
                      className='[ f-icon-020 f-c-st-awa f-m-r-010 ]'
                    />
                    Ihr lokaler Bauberater
                  </div>
                ) : null}
                {person.avatar ? (
                  <img
                    src={person.avatar}
                    className='[ f-bo-round ]'
                    width='64'
                    height='64'
                  />
                ) : (
                  <Icon
                    icon='author-64px-fill'
                    className='[ f-icon-080 f-c-fi-pri ]'
                  />
                )}
                <div className='[ f-t-body f-m-t-010 ] VendorOfficesPage-agent-name'>
                  {person.first_name} {person.last_name}
                </div>
                {person.phone ? (
                  <CTA
                    type='text-primary'
                    tag='button'
                    className='[ f-p-t-005 f-t-body ] VendorOfficesPage-phone-cta'
                    href={showPhoneNumber ? `tel:${person.phone}` : null}
                    onClick={() => handleShowPhoneNumber(person.id)}>
                    {showPhoneNumber.includes(person.id)
                      ? person.phone
                      : 'Telefonnummer anzeigen'}
                  </CTA>
                ) : null}
              </div>
            </div>
          ))}
      </div>
    </div>
  ) : null
}

export default VendorSalesAgentsList
